import { FormulaSelect } from "../FormulaSelect";
import { useMemo } from "react";
import { filteredObjectByValueTypes } from "../helpers/filteredObjectByValueTypes";

const BracketsRender = ({ node, dropdownData, onSelectHandler, component }) => {
  const { argumentsCount, argumentsType } = node;

  const dataForInputs = useMemo(() => {
    return filteredObjectByValueTypes({
      object: dropdownData,
      valueTypes: argumentsType,
    });
  }, [dropdownData, argumentsType]);

  const renderedInputs = argumentsCount.map((currentArgNumber, index) => {
    if (
      argumentsCount.length !== node.children.length &&
      currentArgNumber !== node.children.length
    ) {
      const onSelect = (item) => {
        onSelectHandler(item, {
          currentNodeId: node.id,
          currentChildIndex: currentArgNumber - 1,
        });
      };

      return (
        <>
          <FormulaSelect
            key={index}
            onSelectItem={onSelect}
            dropdownData={dataForInputs}
          />
        </>
      );
    }

    return null;
  });

  return (
    <>
      <span className="function_result_label" key={node.key}>
        {node.label}
      </span>

      {component}

      {renderedInputs}

      <span>)</span>
    </>
  );
};

export default BracketsRender;
